<template>
  <!-- 切换手机验证 - 开始 -->
  <Modal
    v-model="vis"
    :loading="true"
    @on-cancel="cancelHandle"
    :mask-closable="false"
    :title="$t('安全验证')"
  >
    <slot></slot>
    <div class="modal-item" v-if="userInfo.enableEmailCheck === 1">
      <h3>{{ $t('邮箱验证码') }}</h3>
      <div class="verify-code-box">
        <input type="text" v-verify.sms v-model.trim="sms.email" />
        <verify-code
          class="verify-code"
          @click="sendEmailSms"
          :rebase="vis"
        ></verify-code>
      </div>
      <div class="warn-tips">
        {{ $t('输入邮箱') }} {{ userInfo.email | strEncrypt }}
        {{ $t('收到的验证码') }}
      </div>
    </div>

    <div class="modal-item" v-if="userInfo.enablePhoneCheck === 1">
      <h3>{{ $t('短信验证码') }}</h3>
      <div class="verify-code-box">
        <input type="text" v-verify.sms v-model.trim="sms.phone" />
        <verify-code
          class="verify-code"
          @click="sendSms"
          :rebase="vis"
        ></verify-code>
      </div>
      <div class="warn-tips">
        {{ $t('输入手机') }} {{ userInfo.mobilePhone | strEncrypt }}
        {{ $t('收到的验证码') }}
      </div>
    </div>

    <div class="modal-item" v-show="userInfo.enableGoogleCheck == 1">
      <h3>{{ $t('谷歌验证码') }}</h3>
      <input type="text" v-verify.sms v-model.trim="sms.google" />
    </div>

    <template #footer>
      <el-button @click="cancelHandle">{{ $t('取消') }}</el-button>
      <el-button
        type="primary"
        @click="okHandle"
        :loading="btnLoading.confirm"
        >{{ $t('确定') }}</el-button
      >
    </template>
  </Modal>
  <!-- 切换手机验证 - 结束 -->
</template>

<script>
import ModalBase from '@/components/ModalBase'
// 引入 vuex 中的用户信息
import { mapState } from 'vuex'
import { ajaxSmsHandle, ajaxTip } from '@/utils'
import { ajax_sendEmailSms, ajax_sendSms } from '@/api/personal'

export default {
  name: 'SafeVerifyModal',
  extends: ModalBase,
  computed: {
    ...mapState(['userInfo'])
  },
  props: {
    smstype: {
      // 组件内部依据这个数据来发送验证码请求
      type: Number,
      required: true
    }
  },
  data() {
    return {
      sms: {
        email: '',
        phone: '',
        google: ''
      }
    }
  },
  mounted() {
    // 提供外界更改安全验证按钮的loading
    this.$receiver('modify-Public-SafeVerifyModal', 'btnLoading.confirm')
  },
  methods: {
    okHandle() {
      // 判断必要填写的验证码有没有空的，
      if (this.userInfo.enableEmailCheck === 1 && this.sms.email === '') {
        this.$Message.info(this.$t('请填写邮箱验证码！'))
        return
      } else if (
        this.userInfo.enablePhoneCheck === 1 &&
        this.sms.phone === ''
      ) {
        this.$Message.info(this.$t('请填写手机验证码！'))
        return
      } else if (
        this.userInfo.enableGoogleCheck === 1 &&
        this.sms.google === ''
      ) {
        this.$Message.info('请填写Google验证码')
        return
      }
      this.$verify.doVerify()
      if (!this.$verify.default.all) {
        this.$Message.info('验证码格式错误')
        return
      }
      // 触发确认事件，将用户填写的验证码传出去，用于最后的信息修改请求
      this.$emit('on-ok', this.sms)
    },
    cancelHandle() {
      this.vis = false
      this.$emit('on-cancel')
    },
    sendSms($event) {
      // 发送手机验证码
      ajaxSmsHandle(
        ajax_sendSms({
          phone: this.userInfo.mobilePhone,
          areaCode: this.userInfo.areaCode,
          smstype: this.smstype
        }),
        $event
      ).then(ajaxTip)
    },
    sendEmailSms($event) {
      // 发送邮箱验证码
      ajaxSmsHandle(
        ajax_sendEmailSms({
          email: this.userInfo.email,
          smstype: this.smstype
        }),
        $event
      ).then(ajaxTip)
    }
  }
}
</script>
<style scoped lang="less">
@import 'modal.less';

.modal-item {
  .modal-item-base();
}
</style>
